import { render, staticRenderFns } from "./CustomChartWrapper.vue?vue&type=template&id=06c72f31&scoped=true&"
import script from "./CustomChartWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomChartWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CustomChartWrapper.vue?vue&type=style&index=0&id=06c72f31&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c72f31",
  null
  
)

export default component.exports